/*
 * page-header
 */
import { cn } from "../utils"
import { cva, type VariantProps } from "class-variance-authority"
import type { ReactNode } from "react"

export type HeaderProps = VariantProps<typeof headerVariants> & {
	Component?: any
	children: ReactNode
	className?: string
}

export function Header({
	Component = "h2",
	size,
	className,
	children,
}: HeaderProps) {
	return (
		<Component className={cn(headerVariants({ size, className }))}>
			{children}
		</Component>
	)
}

/* Variants */
export const headerVariants = cva("font-sans", {
	variants: {
		size: {
			default: "xs:text-4xl text-3xl sm:text-5xl md:text-6xl lg:text-7xl",
			xs: "xs:text-2xl text-xl sm:text-3xl md:text-4xl lg:text-5xl",
			sm: "xs:text-3xl text-2xl sm:text-4xl md:text-5xl lg:text-6xl",
			lg: "xs:text-5xl text-4xl sm:text-6xl md:text-7xl lg:text-8xl",
			xl: "xs:text-6xl text-5xl sm:text-7xl md:text-8xl lg:text-9xl",
		},
	},
	defaultVariants: {
		size: "default",
	},
})
